/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_InvoiceLineItemDTO = {
    /**
     * AgeType identifies the age category
     * Enum: BABY,CHILD
     */
    age_type?: billing_InvoiceLineItemDTO.age_type;
    /**
     * Amount for this line item in minor currency units (e.g., 48000 = 480.00 in major units)
     */
    amount?: number;
    /**
     * AttendanceDate is the attendance day (YYYY-MM-DD) of a per-unit course line.
     * Only populated when every aggregated item of the row shares the same date.
     */
    attendance_date?: string;
    /**
     * CourseID references the course for course line items
     */
    course_id?: string;
    /**
     * CourseName is the display name for course line items
     */
    course_name?: string;
    /**
     * CoursePlanID references the course plan (a course on a given weekday) for
     * course line items. Two different courses on the same weekday stay separate
     * rows because the aggregation keys on it.
     */
    course_plan_id?: string;
    /**
     * ExtraComment is the parent-facing free-text comment from the child-extras
     * table. Only populated for child-extra line items (ServiceCode prefix
     * "EXTRA_"); the frontend prefers this over the localized type label.
     */
    extra_comment?: string;
    /**
     * Free marks a line the daycare granted at no charge (issue #1390). The
     * amount is 0 and the frontend prints a localized "free" marker next to the
     * service name, so a 0.00 row reads as a granted service rather than a bug.
     */
    free?: boolean;
    /**
     * GroupType identifies the pricing tier
     * Enum: STANDARD,SMALL,LARGE,SPECIAL
     */
    group_type?: billing_InvoiceLineItemDTO.group_type;
    /**
     * MonthDays is the total number of days in the month (for pro-rata temporis calculations)
     * Only populated for partial month scenarios
     */
    month_days?: number;
    /**
     * PeriodDays is the number of days in the billing period (for pro-rata temporis calculations)
     * Only populated for partial month scenarios
     */
    period_days?: number;
    /**
     * Quantity is the raw numeric value for calculations (number of days)
     */
    quantity: number;
    /**
     * QuantityDisplay is deprecated - left empty for frontend i18n formatting
     * Frontend should format quantity using: Quantity, WeekFactor, WeekFactorWhole, PeriodDays, MonthDays
     */
    quantity_display?: string;
    /**
     * ServiceCode identifies the type of service
     */
    service_code?: string;
    /**
     * ServiceDescription for display
     */
    service_description?: string;
    /**
     * Type identifies the line item category used for frontend sub-section grouping
     * Enum: daycare,extra,course,settling_in
     */
    type?: billing_InvoiceLineItemDTO.type;
    /**
     * UnitPrice in minor currency units (e.g., 12000 = 120.00 in major units). Daily rate from tariff.
     */
    unit_price?: number;
    /**
     * WeekFactor is the week factor value for week-based calculations
     * Only populated when calculation method uses week factors
     */
    week_factor?: number;
    /**
     * WeekFactorWhole indicates if the week factor is a whole number (for formatting purposes)
     * Only populated when WeekFactor is present
     */
    week_factor_whole?: boolean;
    /**
     * Weekday represents the day of week as integer (1=Monday, 2=Tuesday, ..., 7=Sunday)
     * Minimum: 1
     * Maximum: 7
     */
    weekday: number;
};
export namespace billing_InvoiceLineItemDTO {
    /**
     * AgeType identifies the age category
     * Enum: BABY,CHILD
     */
    export enum age_type {
        BABY = 'BABY',
        CHILD = 'CHILD',
    }
    /**
     * GroupType identifies the pricing tier
     * Enum: STANDARD,SMALL,LARGE,SPECIAL
     */
    export enum group_type {
        STANDARD = 'STANDARD',
        SMALL = 'SMALL',
        LARGE = 'LARGE',
        SPECIAL = 'SPECIAL',
    }
    /**
     * Type identifies the line item category used for frontend sub-section grouping
     * Enum: daycare,extra,course,settling_in
     */
    export enum type {
        DAYCARE = 'daycare',
        EXTRA = 'extra',
        COURSE = 'course',
        SETTLING_IN = 'settling_in',
    }
}

